import { Alert, Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import StickyButtonContainer from 'components/@saudi-rewards/SaudiRewardsRetroRedeemContainer/StickyButtonContainer';

interface Props {
  onRetry: () => void;
  onContactSupport: () => void;
}

const OrdersErrorState = ({ onRetry, onContactSupport }: Props) => {
  return (
    <Stack
      spacing={2}
      flexGrow={{ xs: 1, md: 0 }}
      justifyContent="space-between"
    >
      <Stack spacing={2} sx={{ pb: 3 }}>
        <Typography variant="h4">
          <FormattedMessage id="error.subtitle" />
        </Typography>
        <Alert severity="error" variant="outlined" sx={{ mt: 2 }}>
          <Typography variant="body1" fontWeight="bold">
            <FormattedMessage id="claim.points.error.title" />
          </Typography>
          <Typography variant="small">
            <FormattedMessage id="claim.points.error.subtitle" />
          </Typography>
        </Alert>
      </Stack>
      <StickyButtonContainer>
        <Stack sx={{ gap: 3 }}>
          <Button variant="outlined" color="secondary" onClick={onRetry}>
            <FormattedMessage id="claim.points.orders.retry" />
          </Button>
          <Button variant="text" onClick={onContactSupport}>
            <FormattedMessage id="claim.points.contact_support" />
          </Button>
        </Stack>
      </StickyButtonContainer>
    </Stack>
  );
};

export default OrdersErrorState;
